import type { CmlContent } from 'bundles/cml';

export enum CourseType {
  STANDARD_COURSE = 'standardCourse',
  RHYME_PROJECT = 'rhymeProject',
  PROJECT = 'project',
}

export type StandardCourseMetadata = {
  typeNameIndex: typeof CourseType.STANDARD_COURSE;
};

export type ProjectMetadata = {
  typeNameIndex: typeof CourseType.PROJECT;
};

export type RhymeProjectMetadata = {
  typeNameIndex: typeof CourseType.RHYME_PROJECT;
  tasks?: Array<CmlContent>;
  screenshotUrls?: Array<string>;
};

export type CourseTypeMetadata = {
  typeName: CourseType;
  definition: StandardCourseMetadata | RhymeProjectMetadata | ProjectMetadata | {};
};
